// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IQaApi,
  IQaApiRequest,
  IQaApiNullResponse,
  IQaApiGetListAttrs,
  IQaApiDeleteAttrs,
  IQaApiListResponse,
  IQaApiGetDetailAttrs,
  IQaApiDetailResponse,
} from 'interfaces/back-office/qa/qa-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class QaApi extends BaseApi<IQaApi> implements IQaApiRequest {
  readonly url = ApiConstant.QA_URL
  private qaUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get Questions
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IQaApiGetListAttrs} payload
   *
   * @return {Promise<IQaApiListResponse>} Promise<IQaApiListResponse>
   */
  async qa_getList(payload: IQaApiGetListAttrs): Promise<IQaApiListResponse> {
    return this.POST(`${this.qaUrl}/list`, payload.body, { ...payload.requestConfig })
  }

  /**
   * @description Get Question
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IQaApiGetDetailAttrs} payload
   *
   * @return {Promise<IQaApiDetailResponse>} Promise<IQaApiDetailResponse>
   */
  async qa_getDetail(payload: IQaApiGetDetailAttrs): Promise<IQaApiDetailResponse> {
    return this.POST(`${this.qaUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Delete question
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IQaApiDeleteAttrs} payload
   *
   * @return {Promise<IQaApiNullResponse>} Promise<IQaApiNullResponse>
   */
  async qa_delete(payload: IQaApiDeleteAttrs): Promise<IQaApiNullResponse> {
    return this.POST(`${this.qaUrl}/delete/${payload.params.id}`, {}, { ...payload.requestConfig })
  }
}
